<template>
  <div v-if="user.role && user.role == 'PGDI'" class="header-PGDI">
    <div class="page-title">
      <img src="../../../../src/assets/Monitoramento.png" />
      <h1>{{ $t("aderencia-dos-indicadores") }}</h1>
    </div>

    <div class="datepicker-container">
      <div class="selector-container">
        <div class="shift">
          <p>{{ $t("turno-0") }}</p>
          <b-form-select v-model="shift" :options="shiftOptions" class="select-box-PGDI"></b-form-select>
        </div>
        <div class="area">
          <p>{{ $t("telas") }}</p>
          <b-form-select v-model="area" :options="areaOptions" class="select-box-PGDI"></b-form-select>
        </div>
      </div>


      <div class="datepicker-input-group">
        <searchDatePicker :lang="ptbr" :shortcuts="shortcuts" v-model="customInterval" class="custom-date" type="date"
          format="DD/MM/YYYY" range placeholder="Intervalo da busca" range-separator="  até  ">
          <template v-slot:input="slotProps">
            <input type="text" v-bind="slotProps.props" v-on="slotProps.events" />
          </template>

          <template v-slot:icon-calendar>
            <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512">
              <path
                d="M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm64 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm128 0v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H336zM64 400v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H208zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16z" />
            </svg>
          </template>
        </searchDatePicker>
      </div>
    </div>

    <div class="search-container">
      <div class="search-button-group-img">
        <img v-if="!loadingReport" @click="this.loadCharts" src="../../../assets/buscar.png" :title="$t('pesquisar-0')" />
        <span v-else class="spinner-border spinner-border-sm spinnerConfig" role="status" aria-hidden="true"
          :title="$t('por-favor-aguarde-o-carregamento')"></span>
      </div>
      <div class="excel">
        <download-excel :name="getNameFileExcel()" :fetch="GerarExcel">
          <img v-if="!generateExcel" class="printer-button" src="../../../assets/excel.png"
            :title="$t('exportar-aderencia-dos-indicadores')" alt="$t('imprimir')" />
          <span v-else class="spinner-border spinner-border-sm spinnerConfig" role="status" aria-hidden="true"
            :title="$t('por-favor-aguarde-exportacao')"></span>
        </download-excel>
      </div>
    </div>

  </div>

  <div v-else class="header-GDI">
    <div class="go-back-buttom">
      <img src="@/assets/regressar.png" :title="$t('voltar')" :alt="$t('botao-voltar')" @click="backFlow" />
    </div>

    <div class="page-title-GDI">
      <img src="../../../../src/assets/Monitoramento.png" />
      <h1>{{ $t("aderencia-dos-indicadores") }}</h1>
    </div>

    <div class="productive-unit">{{ unit.name }}</div>



    <div class="datepicker-container">
      <div class="selector-container">
        <div class="shift">
          <p>{{ $t("turno-0") }}</p>
          <b-form-select v-model="shift" :options="shiftOptions" class="select-box-PGDI"></b-form-select>
        </div>
        <div class="area">
          <p>{{ $t("telas") }}</p>
          <b-form-select v-model="area" :options="areaOptions" class="select-box-PGDI"></b-form-select>
        </div>
      </div>


      <div class="datepicker-input-group">
        <searchDatePicker :lang="ptbr" :shortcuts="shortcuts" v-model="customInterval" class="custom-date" type="date"
          format="DD/MM/YYYY" range placeholder="Intervalo da busca" range-separator="  até  ">
          <template v-slot:input="slotProps">
            <input type="text" v-bind="slotProps.props" v-on="slotProps.events" />
          </template>

          <template v-slot:icon-calendar>
            <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512">
              <path
                d="M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm64 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm128 0v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H336zM64 400v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H208zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16z" />
            </svg>
          </template>
        </searchDatePicker>
      </div>
    </div>

    <div class="search-container">
      <div class="search-button-group-img">
        <img v-if="!loadingReport" @click="this.loadCharts" src="../../../assets/buscar.png" :title="$t('pesquisar-0')" />
        <span v-else class="spinner-border spinner-border-sm spinnerConfig" role="status" aria-hidden="true"
          :title="$t('por-favor-aguarde-o-carregamento')"></span>
      </div>
      <div class="excel">
        <download-excel :name="getNameFileExcel()" :fetch="GerarExcel">
          <img v-if="!generateExcel" class="printer-button" src="../../../assets/excel.png"
            :title="$t('exportar-aderencia-dos-indicadores')" alt="$t('imprimir')" />
          <span v-else class="spinner-border spinner-border-sm spinnerConfig" role="status" aria-hidden="true"
            :title="$t('por-favor-aguarde-exportacao')"></span>
        </download-excel>
      </div>
    </div>
  </div>
</template>

<script>
import Mediator from "../utilites/Mediator";
import MediatorGDI from "../utilites/MediatorGDI";
import { showError, defaultSuccess, urlMainAPI } from "@/global";
import * as moment from "moment";
import { mapState } from "vuex";
import axios from "axios";
import searchDatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import ptbr from 'vue2-datepicker/locale/pt-br'

export default {
  name: "AdherenceIndicatorsHeader",
  components: { searchDatePicker },

  computed: mapState(["user"]),

  data: function () {
    return {
      name: "AdherenceIndicatorsHeader",
      loadingReport: false,
      area: "",
      areaGDI: "",
      shift: "4",
      unit: "",
      parameterSearch: {},
      shiftOptions: [],
      areaOptions: [],
      startDate: null,
      endDate: null,
      generateExcel: false,
      ptbr: {
        ...ptbr,
        monthFormat: 'MMMM'
      },
      customInterval: [],
      shortcuts: [],
    };
  },

  methods: {
    async getInfosScreensAndWorkshift() {
      this.loadingReport = true;
      this.generateExcel = true;
      const url = `${urlMainAPI}/getlistworkshiftandarea`;
      await axios
        .get(url)
        .then((res) => {
          this.areaOptions = [];
          Object.keys(res.data.area).forEach((item) => {
            let itemForDictionary = res.data.area[item];
            let dictionaryAreaItem = {
              value: itemForDictionary,
              text: itemForDictionary,
            };
            this.areaOptions.push(dictionaryAreaItem);
          });

          this.shiftOptions = res.data.workshift;
          this.shiftOptions["4"] = this.$t("geral");

          if (this.user.role == "GDI") {
            this.areaOptions = this.areaOptions.filter((a) => {
              return a.value.includes(this.unit.initials);
            });
            this.area = this.areaOptions.find((a) =>
              a.value.includes(this.areaGDI)
            ).value;
          } else {
            this.area = this.areaOptions.find(x => x.value.includes('COI') || x.value.includes('GERAL')).value;
          }

        })
        .catch((e) => {
          console.log(e);
        });

      if (!JSON.parse(localStorage.getItem("dataToGraph"))) {
        Mediator.mainScreen.waitingLoadChart = false;
      }

      this.loadingReport = false;
      this.generateExcel = false;

    },

    getNameFileExcel() {
      return `Relatório de Aderência dos Indicadores - ${this.user.UnitName}`
    },

    backFlow() {
      this.$router.push({
        name: "adherenceindicatorsgdi",
      });
      MediatorGDI.notify("", "back-to-gdi");
    },

    dateIsOk() {
      if (!this.customInterval[0] || !this.customInterval[1]) return false;

      if (this.customInterval[0] > this.customInterval[1]) {
        showError(this.$t('initialDate-should-after-finaldate'));
        return false;
      }

      let today = new Date();

      if (this.customInterval[0] > today) {
        showError(this.$t('initialdate-after-futredate'));
        return false;
      }

      let totalIntervalDays = Math.ceil((this.customInterval[1] - this.customInterval[0]) / (1000 * 3600 * 24));

      if (this.user.Permissions.limitarbuscaaderencias && this.user.Permissions.limitarbuscaaderencias.allowed == true) {
        if (this.user.userRoleDescription &&
          this.user.userRoleDescription != "Administrativo" &&
          this.user.searchLimit &&
          totalIntervalDays >= Number(this.user.searchLimit)) {
          showError(this.$t('interval-maxdays') + `${this.user.searchLimit}`);
          return false;
        }
      }

      if (totalIntervalDays > 365) {
        showError(this.$t('limit-interval-shouldnot-pass30days'));
        return false;
      }

      this.startDate = moment(this.customInterval[0]).format('YYYY-MM-DD');
      this.endDate = moment(this.customInterval[1]).format('YYYY-MM-DD');

      return true;
    },

    validateSearchParams() {
      if (this.customInterval.length <= 0 || this.customInterval[0] == null || this.customInterval[1] == null) {
        showError(this.$t('valid-interval-indicator'));
        return false
      }

      if (!this.area || !this.shift) {
        showError(this.$t("selecione-a-tela"));
        return false;
      }

      if (!this.dateIsOk()) return false;

      return true
    },

    async getEnable(area, shift) {
      if (!this.validateSearchParams()) return;

      this.parameterSearch = {
        shift: shift,
        area: area,
        dateInitial: this.startDate,
        dateFinal: this.endDate
      };

      defaultSuccess(this.$t("carregando-dados-1"));
      this.loadingReport = true;
      await Mediator.notify(this.parameterSearch, "changeScreen");
      this.loadingReport = false;
    },

    async GerarExcel() {
      if (!this.validateSearchParams()) return;

      this.generateExcel = true;

      defaultSuccess(this.$t("gerando-excel-de-aderencia-dos-indicadores"));

      const url = `${urlMainAPI}/getindicatoradherenceDailyreport/${this.area}/${this.startDate}/${this.endDate}/${this.shift}/${this.$route.params.unitId}/true`;

      const response = await this.$http.get(url);
      this.generateExcel = false;
      if (response.data.length == 0) {
        defaultSuccess(this.$t("excel-zerado"));
      } else {
        defaultSuccess(this.$t("excel-exportado-com-sucesso"));
      }
      return response.data;
    },

    async loadCharts() {
      await this.getEnable(this.area, this.shift);
    },
  },

  async created() {
    await this.getInfosScreensAndWorkshift();

    let parameterSearch = JSON.parse(localStorage.getItem("parameterSearch"));

    if (parameterSearch) {
      this.startDate = parameterSearch.dateInitial
      this.endDate = parameterSearch.dateFinal
      this.customInterval = [new Date(`${parameterSearch.dateInitial} 00:00:00`), new Date(`${parameterSearch.dateFinal} 00:00:00`)]
      this.area = parameterSearch.area
      this.shift = parameterSearch.shift
    }


  },

  mounted() {
    if (this.user.role && this.user.role == "GDI") MediatorGDI.notify(this, "init-header-pgdi");

    if ((this.user.userRoleDescription && this.user.userRoleDescription == "Administrativo") ||
      !this.user.Permissions.limitarbuscaaderencias || this.user.Permissions.limitarbuscaaderencias.allowed == false) 
    {
      this.shortcuts.push(
        {
          text: 'Hoje',
          onClick: () => {
            this.customInterval = [new Date(), new Date()];
          }
        },
        {
          text: '2 dias',
          onClick: () => {
            let two = new Date();
            two.setDate(two.getDate() - 1)
            this.customInterval = [two, new Date()];
          }
        },
        {
          text: '3 dias',
          onClick: () => {
            let three = new Date();
            three.setDate(three.getDate() - 2)
            this.customInterval = [three, new Date()];
          }
        },
        {
          text: '5 dias',
          onClick: () => {
            let five = new Date();
            five.setDate(five.getDate() - 4)
            this.customInterval = [five, new Date()];
          }
        },
        {
          text: '7 dias',
          onClick: () => {
            let seven = new Date();
            seven.setDate(seven.getDate() - 6)
            this.customInterval = [seven, new Date()];
          }
        },
        {
          text: '15 dias',
          onClick: () => {
            let fifteen = new Date();
            fifteen.setDate(fifteen.getDate() - 14)
            this.customInterval = [fifteen, new Date()];
          }
        }
      )
    }else{
      this.shortcuts = []
    }
  },
};
</script>

<style scoped>
.page-title {
  display: flex;
}

.header-PGDI {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  column-gap: 0.8rem;
  padding-left: 0.8rem;
  padding-right: 2rem;
  align-items: center;
}

.header-PGDI h1 {
  margin-left: 10px;
  font-size: 2rem;
}

img {
  max-height: 35px;
}

.datepicker-container {
  display: flex;
  column-gap: 2rem;
  margin-left: auto;
  margin-right: 1rem;
}

.datepicker-container .selector-container {
  display: flex;
  column-gap: 1.5rem;
}

.datepicker-container .selector-container .shift,
.datepicker-container .selector-container .area {
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 0.5rem;
}

.datepicker-container .selector-container .shift p,
.datepicker-container .selector-container .area p {
  margin: 0;
}

.datepicker-container .selector-container select {
  border: 1px solid #ff5f00;
}

.datepicker-container input[type="text"] {
  border: 1px solid #ff5f00;
  border-radius: 3px;
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  font-weight: 400;
  color: #495057;
  height: 100%;
}

.datepicker-container i>svg {
  fill: #ff5f00;
}

.datepicker-container input[type="text"]:not(:placeholder-shown) {
  background-color: #ff5f00;
  color: #ffffff;
  font-weight: 600;
}

.datepicker-container input[type="text"]:not(:placeholder-shown)+i>svg {
  fill: #ffffff;
}

.datepicker-container .datepicker-input-group {
  display: flex;
  align-items: center;
  column-gap: 0.5rem;
}

.search-container {
  display: flex;
  column-gap: 1.5rem;
}


.search-container .search-button-group-img,
.search-container .excel {
  cursor: pointer;
}

.search-container .spinnerConfig {
  width: 1.5rem;
  height: 1.5rem;
  margin-left: 10px;
  margin-top: 8px;
  color: #ff5f00;
}

.header-GDI {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  column-gap: 1.5rem;
  padding-left: 0.8rem;
  padding-right: 2rem;
  align-items: center;
}

.page-title-GDI {
  display: flex;
}

.header-GDI h1 {
  margin-left: 10px;
  font-size: 2rem;
}

.productive-unit {
  font-size: 1.4rem;
  font-weight: 600;
}

.go-back-buttom {
  margin-left: 5px;
}

img {
  max-height: 35px;
}
</style>
